module.exports = __webpack_public_path__ + "img/bootstrap-logo.7f4a6cf0.png";